import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

const MathCaptcha = ({ onVerify, language = 'de' }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(false);

  const generateNewQuestion = () => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
    setUserAnswer('');
    setIsVerified(false);
    setError(false);
  };

  useEffect(() => {
    generateNewQuestion();
  }, []);

  useEffect(() => {
    // Verify as user types
    if (userAnswer) {
      const correctAnswer = num1 + num2;
      const isCorrect = parseInt(userAnswer) === correctAnswer;
      setIsVerified(isCorrect);
      setError(!isCorrect && userAnswer.length > 0);
      onVerify(isCorrect);
    } else {
      setIsVerified(false);
      setError(false);
      onVerify(false);
    }
  }, [userAnswer, num1, num2, onVerify]);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {language === 'de' ? 'Sicherheitsfrage' : 'Security Question'} *
      </label>
      <div className="flex items-center space-x-3">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <div className="bg-gray-100 px-4 py-2 rounded-lg font-mono text-lg font-semibold">
              {num1} + {num2} = ?
            </div>
            <button
              type="button"
              onClick={generateNewQuestion}
              className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
              title={language === 'de' ? 'Neue Frage' : 'New Question'}
            >
              <RefreshCw className="w-5 h-5" />
            </button>
          </div>
          <input
            type="number"
            value={userAnswer}
            onChange={(e) => setUserAnswer(e.target.value)}
            placeholder={language === 'de' ? 'Ihre Antwort' : 'Your answer'}
            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent ${
              isVerified
                ? 'border-green-500 bg-green-50'
                : error
                ? 'border-red-500 bg-red-50'
                : 'border-gray-300'
            }`}
            required
          />
        </div>
        {isVerified && (
          <div className="flex-shrink-0">
            <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        )}
      </div>
      {error && (
        <p className="text-sm text-red-600">
          {language === 'de' ? 'Falsche Antwort, bitte versuchen Sie es erneut.' : 'Wrong answer, please try again.'}
        </p>
      )}
      {isVerified && (
        <p className="text-sm text-green-600">
          {language === 'de' ? '✓ Verifiziert' : '✓ Verified'}
        </p>
      )}
    </div>
  );
};

export default MathCaptcha;
